"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var _shared = require("./shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Text = _typography.default.Text;
var adminListConfig = function adminListConfig(dataSource, onRowClick) {
  var _classMap;
  var classMap = (_classMap = {}, _defineProperty(_classMap, _utils.AccountStatus.New, 'new'), _defineProperty(_classMap, _utils.AccountStatus.Active, 'active'), _defineProperty(_classMap, _utils.AccountStatus.Deactivated, 'inactive'), _classMap);
  var roles = (0, _utils.reformatDictionary)((0, _utils.getAdminRoles)().map(function (_ref) {
    var value = _ref.value,
      text = _ref.text;
    return {
      id: value,
      label: text
    };
  }));
  var onRow = function onRow(record) {
    return {
      onClick: function onClick() {
        return onRowClick(record);
      }
    };
  };
  var columns = [{
    title: 'Status',
    dataIndex: 'status',
    filters: _shared.statusColumnConfig.filters,
    onFilter: (0, _utils.filter)('status'),
    defaultSortOrder: 'ascend',
    sorter: (0, _utils.preferredOrderSorter)('status', [_utils.AccountStatus.Active, _utils.AccountStatus.Deactivated, _utils.AccountStatus.New]),
    sortDirections: [false],
    render: function render(id, record) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "clinician-".concat(classMap[record.status])
      }, _shared.statusColumnConfig.render[record.status]);
    },
    width: '10%'
  }, {
    title: 'Name',
    dataIndex: 'name',
    sorter: (0, _utils.multiStringSorter)(['lastName', 'firstName']),
    render: _shared.renderNameColumn,
    width: '15%'
  }, {
    title: 'Role',
    dataIndex: 'role',
    filters: roles.filters,
    onFilter: (0, _utils.filter)('role'),
    sorter: (0, _utils.stringSorter)('role'),
    render: (0, _utils.renderColumn)(roles, 'role'),
    width: '15%'
  }, {
    title: 'Nickname',
    dataIndex: 'nickName',
    sorter: (0, _utils.stringSorter)('nickName'),
    width: '15%'
  }, {
    title: 'Email',
    dataIndex: 'email',
    sorter: (0, _utils.stringSorter)('email'),
    width: '15%'
  }, {
    title: 'Company',
    dataIndex: 'companyId',
    filters: _shared.companyColumnConfig.filters,
    onFilter: (0, _utils.filter)('companyId'),
    sorter: (0, _utils.stringSorter)('companyId'),
    render: (0, _utils.renderColumn)(_shared.companyColumnConfig, 'companyId'),
    width: '10%'
  }, {
    title: 'Last activity',
    dataIndex: 'lastActivityDate',
    render: function render(id, record) {
      return /*#__PURE__*/_react.default.createElement(Text, {
        type: "secondary"
      }, (0, _utils.formatDate)(record.lastActivityDate));
    },
    sorter: (0, _utils.timeSorter)('lastActivityDate'),
    width: '20%'
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    onRow: onRow,
    rowKey: 'id'
  };
};
var _default = adminListConfig;
exports.default = _default;